import * as sagaEffects from 'redux-saga/effects';

import handlePartnersRequest from './handlePartnersRequest';
import handleUpdatePartnersRequest from './handleUpdatePartnersRequest';

const { all } = sagaEffects;

export default function* () {
    yield all([handlePartnersRequest(), handleUpdatePartnersRequest()]);
}
